<template>
  <div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Device Name:</span>
      <span class="text-sm">{{ systemInfo.deviceName || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">IP Address:</span>
      <span class="text-sm">{{ systemInfo.ip || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">MAC Address:</span>
      <span class="text-sm">{{ systemInfo.mac || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Serial Number:</span>
      <span class="text-sm">{{ systemInfo.sn || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Hardware Version:</span>
      <span class="text-sm">{{ systemInfo.hardwareVersion || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Software Version:</span>
      <span class="text-sm">{{ systemInfo.softwareVersion || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">CPU Usage:</span>
      <span class="text-sm">{{ systemInfo.cpuPercent || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Memory Usage:</span>
      <span class="text-sm">{{ systemInfo.memoryPercent || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">System Time:</span>
      <span class="text-sm">{{ systemInfo.sysTime || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Uptime:</span>
      <span class="text-sm">{{ formatUptime(systemInfo.runTime) || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Gateway:</span>
      <span class="text-sm">{{ systemInfo.gateway || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Subnet Mask:</span>
      <span class="text-sm">{{ systemInfo.mask || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">DNS Type:</span>
      <span class="text-sm">{{ systemInfo.dnsType || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Preferred DNS:</span>
      <span class="text-sm">{{ systemInfo.preferredDNS || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Alternate DNS:</span>
      <span class="text-sm">{{ systemInfo.alternateDNS || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Device Location:</span>
      <span class="text-sm">{{ systemInfo.deviceLocation || 'N/A' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TbsEponSystemInfo',
  props: {
    systemInfo: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  methods: {
    formatUptime(seconds) {
      if (!seconds) return 'N/A';
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${days}d ${hours}h ${minutes}m ${secs}s`;
    }
  }
}
</script>

